// Minimalist icons for Backtest card: Save, Load, Duplicate, Reset.
// Use currentColor so parent can control color (e.g. text-ink).

export function SaveIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      {/* Arrow pointing down into open-top box */}
      <path d="M12 3v12" />
      <path d="m8 11 4 4 4-4" />
      <path d="M6 20V17h12v3" />
    </svg>
  );
}

export function LoadIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      {/* Arrow pointing up out of box (box has open bottom) */}
      <path d="M6 4h12M6 4v3M18 4v3" />
      <path d="M12 21V9" />
      <path d="m8 13 4-4 4 4" />
    </svg>
  );
}

export function DuplicateIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      {/* Two overlapping documents with small arrow suggesting copy */}
      <rect x="4" y="4" width="12" height="16" rx="1" />
      <rect x="8" y="8" width="12" height="16" rx="1" />
      <path d="M12 8v4M10 10h4" />
    </svg>
  );
}

export function ResetIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      {/* Curved clockwise arrow (reload/refresh) */}
      <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
      <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
      <path d="M21 21v-5h-5" />
    </svg>
  );
}
